module.exports = __webpack_public_path__ + "img/icon4.e6880e3e.png";